import React from "react";
import { Search } from "lucide-react";
import NarrativeAssessmentCardBase from "./NarrativeAssessmentCardBase";

const GoogleSearchConsoleNarrativeAssessmentViewer = ({ markdown = "" }) => (
  <NarrativeAssessmentCardBase
    markdown={markdown}
    Icon={Search}
    subtitle="Indexing, visibility, and search engagement interpretation"
    badge="GSC"
    theme={{
      cardBg: "#e8f5ff",
      cardBorder: "#c5d9ff",
      heroBg: "#c6d9ff",
      heroBorder: "#9bbefb",
      badgeBg: "rgba(59, 130, 246, 0.14)",
      badgeBorder: "#2563eb",
      iconColor: "#1d4ed8",
      dotColor: "#2563eb",
    }}
  />
);

export default GoogleSearchConsoleNarrativeAssessmentViewer;
